"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react"); // tslint:disable:import-name match-default-export-name


var react_iframe_comm_1 = require("react-iframe-comm"); // tslint:enable:import-name match-default-export-name


var component_1 = require("../component");

var context_1 = require("../context");

var SpringContainerClass =
/** @class */
function (_super) {
  __extends(SpringContainerClass, _super);

  function SpringContainerClass(props) {
    var _this = _super.call(this, props) || this;

    _this.onReady = function () {
      return;
    };

    _this.onReceiveMessage = function (msg) {
      var data = msg.data;
      var springContext = _this.props.springContext;

      switch (data.type) {
        case 'selected-category-update':
        case 'selected-cells-update':
          {
            springContext.update(data.payload.indices, data.payload.currentCategory);
            break;
          }

        case 'loaded':
          {
            _this.setState({
              postMessageData: {
                payload: {
                  indices: springContext.currentCells.toArray()
                },
                type: 'init'
              }
            });
          }

        default:
          {
            console.log("Got this msg for ya: " + JSON.stringify(msg));
          }
      }
    };

    _this.generateSpringURL = function (dataset) {
      return window.location.origin + "/" + window.location.pathname.substr(0, window.location.pathname.lastIndexOf('/')) + "/springViewer.html?datasets/" + dataset;
    };

    _this.state = {
      postMessageData: {
        payload: {},
        type: 'init'
      },
      springUrl: _this.generateSpringURL(_this.props.datasetLocation)
    };
    return _this;
  }

  SpringContainerClass.prototype.componentDidUpdate = function (prevProps, prevState) {
    var springContext = this.props.springContext;

    if (!prevProps.springContext.currentCells.equals(springContext.currentCells)) {
      console.log("sending new cells to spring, totalling " + springContext.currentCells.size);
      this.setState({
        postMessageData: {
          payload: {
            indices: springContext.currentCells.toArray()
          },
          type: 'selected-cells-update'
        }
      });
    } else if (prevProps.datasetLocation !== this.props.datasetLocation) {
      this.setState({
        springUrl: this.generateSpringURL(this.props.datasetLocation)
      });
    }
  };

  SpringContainerClass.prototype.render = function () {
    var _a = this.props,
        isFullPage = _a.isFullPage,
        springHeight = _a.springHeight,
        springWidth = _a.springWidth;
    var _b = this.state,
        postMessageData = _b.postMessageData,
        springUrl = _b.springUrl;
    var attributes = {
      allowFullScreen: true,
      height: springHeight,
      src: springUrl,
      width: springWidth
    };
    var targetOriginPieces = springUrl.split('/');
    return React.createElement(component_1.ComponentCard, {
      componentName: SpringContainerClass.displayName,
      isFramedComponent: true,
      isFullPage: isFullPage,
      frameHeight: springHeight,
      frameWidth: springWidth,
      height: '500px'
    }, React.createElement(react_iframe_comm_1.default, {
      attributes: attributes,
      postMessageData: postMessageData,
      handleReady: this.onReady,
      handleReceiveMessage: this.onReceiveMessage,
      targetOrigin: targetOriginPieces[0] + "//" + targetOriginPieces[2]
    }));
  };

  SpringContainerClass.defaultProps = {
    data: {
      links: new Array(),
      nodes: new Array()
    },
    datasetLocation: 'hpc/full',
    headerHeight: 32,
    isFullPage: false,
    padding: 0,
    selectedCategory: '',
    springContext: __assign({}, context_1.initialSpringContext),
    springHeight: 1150,
    springWidth: 1150
  };
  SpringContainerClass.displayName = 'SPRING';
  return SpringContainerClass;
}(React.Component);

exports.SpringContainerClass = SpringContainerClass;

exports.SpringContainer = function (props) {
  return React.createElement(context_1.SpringContext.Consumer, null, function (springContext) {
    return React.createElement(SpringContainerClass, __assign({}, props, {
      springContext: springContext
    }));
  });
};